import styled from 'styled-components';

import { ArtworkTableTheme, Breakpoint, Color, FontWeight } from '../../enums';
import { StyledComponent } from '../../interfaces';

import { LabelProps, RowProps } from './artworkTable.types';

export const Container: StyledComponent<'div'> = styled.div``;

export const Row: StyledComponent<'div', RowProps> = styled.div<RowProps>`
  font-size: 16px;
  line-height: 22px;
  display: flex;
  flex-direction: ${({ $theme }: RowProps): string => $theme === ArtworkTableTheme.Horizontal ? 'row' : 'column'};

  & + & {
    margin-top: 16px;
  }
`;

export const Label: StyledComponent<'div', LabelProps> = styled.div<LabelProps>`
  width: ${({ $theme }: LabelProps): string => $theme === ArtworkTableTheme.Horizontal ? '180px' : 'unset'};
  font-weight: ${FontWeight.Light};
  margin-right: ${({ $theme }: LabelProps): string => $theme === ArtworkTableTheme.Horizontal ? '60px' : '0'};
  margin-bottom: ${({ $theme }: LabelProps): string => $theme === ArtworkTableTheme.Horizontal ? '0' : '4px'};
  color: ${Color.Gray400};

  @media ${Breakpoint.SmallMobile} {
    width: ${({ $theme }: LabelProps): string => $theme === ArtworkTableTheme.Horizontal ? '40%' : 'unset'};
    flex-shrink: 0;
  }
`;

export const Value: StyledComponent<'div'> = styled.div`
  flex: 2;
  white-space: pre-wrap;
  
  @media ${Breakpoint.SmallMobile} {
    flex: 0;
  }
`;
